import { createFileRoute } from '@tanstack/react-router'
import { ProjectsPage } from '@/pages/projects'

export const Route = createFileRoute('/_authenticated/projects/')({
  staticData: { title: 'Projects' },
  // The page reads its filters from the URL itself; this only types `stage` for the homepage links.
  validateSearch: (search: Record<string, unknown>) => search as { stage?: string },
  component: ProjectsPage,
})
